import styled from 'styled-components'
import { color, space, typography } from 'styled-system'

const Label = styled.label`
  display: block;
  color: light-dark(var(--brand-grey-500), var(--brand-grey-200));
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-base);
  ${color}
  ${space}
  ${typography}
`

export default Label
